<template>
  <footer class="border-t border-gray-300 py-6 px-6 bg-white my-4" role="contentinfo">
    <div
      class="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center justify-between text-gray-600 text-sm"
    >
      <!-- Copyright -->
      <p class="mb-3 md:mb-0" v-if="!isWhiteLabel">
        <small>&copy; {{ currentYear }} {{ appName }}. All rights reserved. (0.0.41)</small>
      </p>
      <p class="mb-3 md:mb-0" v-else>
        <small>&copy; {{ currentYear }} {{ appName }}. All rights reserved. (0.0.41)</small>
      </p>

      <!-- Socials (hidden on white-labelled tenant landing pages) -->
      <ul v-if="!isWhiteLabel"
        class="flex items-center gap-4 list-none m-0 p-0 mb-3 md:mb-0"
        aria-label="Social media">
        <li>
          <a href="https://www.instagram.com/gradeverse?igsh=MXg4bjdmOThzYmlydA=="
            target="_blank" rel="noopener noreferrer"
            aria-label="Gradeverse on Instagram"
            class="text-gray-500 hover:text-[#1A56DB] transition">
            <i class="pi pi-instagram text-lg"></i>
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/share/1G6MH4zyVV/"
            target="_blank" rel="noopener noreferrer"
            aria-label="Gradeverse on Facebook"
            class="text-gray-500 hover:text-[#1A56DB] transition">
            <i class="pi pi-facebook text-lg"></i>
          </a>
        </li>
      </ul>

      <!-- Footer nav -->
      <nav aria-label="Footer">
        <ul class="flex space-x-6 list-none m-0 p-0">
          <li v-if="!isWhiteLabel"><a href="mailto:support@gradeverse.com" class="hover:text-[#1A56DB] transition">Support</a></li>
          <li><a href="#" class="hover:text-[#1A56DB] transition">Terms of Service</a></li>
          <li><a href="#" class="hover:text-[#1A56DB] transition">Privacy Policy</a></li>
        </ul>
      </nav>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useBranding } from '@/composables/useBranding';

const { appName, isWhiteLabel } = useBranding();
const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped></style>
